module.exports = __webpack_public_path__ + "img/p-40.b7f70b1f.png";